var items = {
  "block.minecraft.air": "һава",
  "block.minecraft.stone": "таш",
  "block.minecraft.granite": "гранит",
  "block.minecraft.polished_granite": "шомартылган гранит",
  "block.minecraft.diorite": "диорит",
  "block.minecraft.polished_diorite": "шомартылган диорит",
  "block.minecraft.andesite": "андезит",
  "block.minecraft.polished_andesite": "шомартылган андезит",
  "block.minecraft.grass_block": "кәс",
  "block.minecraft.dirt": "җир",
  "block.minecraft.coarse_dirt": "ташлы балчык",
  "block.minecraft.podzol": "көлсу туфрак",
  "block.minecraft.crimson_nylium": "кырмызы нәлек",
  "block.minecraft.warped_nylium": "гаҗәп нәлек",
  "block.minecraft.cobblestone": "йомрыташ",
  "block.minecraft.oak_planks": "имән такталар",
  "block.minecraft.spruce_planks": "чыршы такталар",
  "block.minecraft.birch_planks": "каен такталар",
  "block.minecraft.jungle_planks": "тропик агач такталар",
  "block.minecraft.acacia_planks": "сәрви такталар",
  "block.minecraft.dark_oak_planks": "кара имән такталар",
  "block.minecraft.crimson_planks": "кырмызы такталар",
  "block.minecraft.warped_planks": "гаҗәп такталар",
  "block.minecraft.oak_sapling": "имән үсентесе",
  "block.minecraft.spruce_sapling": "чыршы үсентесе",
  "block.minecraft.birch_sapling": "каен үсентесе",
  "block.minecraft.jungle_sapling": "тропик агач үсентесе",
  "block.minecraft.acacia_sapling": "сәрви үсентесе",
  "block.minecraft.dark_oak_sapling": "кара имән үсентесе",
  "block.minecraft.bedrock": "бедрок",
  "block.minecraft.sand": "ком",
  "block.minecraft.red_sand": "кызыл ком",
  "block.minecraft.gravel": "чуерташ",
  "block.minecraft.gold_ore": "алтын кызылы",
  "block.minecraft.iron_ore": "тимер кызылы",
  "block.minecraft.coal_ore": "ташкүмер",
  "block.minecraft.nether_gold_ore": "незер-алтын кызылы",
  "block.minecraft.oak_log": "имән бүрәнә",
  "block.minecraft.spruce_log": "чыршы бүрәнә",
  "block.minecraft.birch_log": "каен бүрәнә",
  "block.minecraft.jungle_log": "тропик агач бүрәнә",
  "block.minecraft.acacia_log": "сәрви бүрәнә",
  "block.minecraft.dark_oak_log": "кара имән бүрәнә",
  "block.minecraft.crimson_stem": "кырмызы сабак",
  "block.minecraft.warped_stem": "гаҗәп сабак",
  "block.minecraft.stripped_oak_log": "юнылган имән бүрәнә",
  "block.minecraft.stripped_spruce_log": "юнылган чыршы бүрәнә",
  "block.minecraft.stripped_birch_log": "юнылган каен бүрәнә",
  "block.minecraft.stripped_jungle_log": "юнылган тропик агач бүрәнә",
  "block.minecraft.stripped_acacia_log": "юнылган сәрви бүрәнә",
  "block.minecraft.stripped_dark_oak_log": "юнылган кара имән бүрәнә",
  "block.minecraft.stripped_crimson_stem": "тазартылган кырмызы сабак",
  "block.minecraft.stripped_warped_stem": "тазартылган гаҗәп сабак",
  "block.minecraft.stripped_oak_wood": "юнылган имән",
  "block.minecraft.stripped_spruce_wood": "юнылган чыршы",
  "block.minecraft.stripped_birch_wood": "юнылган каен",
  "block.minecraft.stripped_jungle_wood": "юнылган тропик агач",
  "block.minecraft.stripped_acacia_wood": "юнылган сәрви",
  "block.minecraft.stripped_dark_oak_wood": "юнылган кара имән",
  "block.minecraft.stripped_crimson_hyphae": "тазартылган кырмызы җепселләре",
  "block.minecraft.stripped_warped_hyphae": "тазартылган гаҗәп җепселләре",
  "block.minecraft.oak_wood": "имән",
  "block.minecraft.spruce_wood": "чыршы",
  "block.minecraft.birch_wood": "каен",
  "block.minecraft.jungle_wood": "тропик агач",
  "block.minecraft.acacia_wood": "сәрви",
  "block.minecraft.dark_oak_wood": "кара имән",
  "block.minecraft.crimson_hyphae": "кырмызы җепселләр",
  "block.minecraft.warped_hyphae": "гаҗәп җепселләре",
  "block.minecraft.oak_leaves": "имән яфраклары",
  "block.minecraft.spruce_leaves": "чыршы яфраклары",
  "block.minecraft.birch_leaves": "каен яфраклары",
  "block.minecraft.jungle_leaves": "тропик агач яфраклары",
  "block.minecraft.acacia_leaves": "сәрви яфраклары",
  "block.minecraft.dark_oak_leaves": "кара имән яфраклары",
  "block.minecraft.sponge": "болыт",
  "block.minecraft.wet_sponge": "юеш болыт",
  "block.minecraft.glass": "пыяла",
  "block.minecraft.lapis_ore": "лазурит кызылы",
  "block.minecraft.lapis_block": "лазурит блок",
  "block.minecraft.dispenser": "өләшүче",
  "block.minecraft.sandstone": "комташ",
  "block.minecraft.chiseled_sandstone": "кисек комташ",
  "block.minecraft.cut_sandstone": "шома комташ",
  "block.minecraft.note_block": "ноталар блогы",
  "block.minecraft.powered_rail": "куәтле тимер юл",
  "block.minecraft.detector_rail": "детекторлы тимер юл",
  "block.minecraft.sticky_piston": "ябышкак пешкәк",
  "block.minecraft.cobweb": "пәрәвез",
  "block.minecraft.grass": "үлән",
  "block.minecraft.fern": "абага",
  "block.minecraft.dead_bush": "үле куак",
  "block.minecraft.seagrass": "диңгез үләне",
  "block.minecraft.sea_pickle": "диңгез кыяры",
  "block.minecraft.piston": "пешкәк",
  "block.minecraft.white_wool": "ак йон",
  "block.minecraft.orange_wool": "кызгылт сары йон",
  "block.minecraft.magenta_wool": "куе кызыл йон",
  "block.minecraft.light_blue_wool": "зәңгәрсу йон",
  "block.minecraft.yellow_wool": "сары йон",
  "block.minecraft.lime_wool": "яшькелт йон",
  "block.minecraft.pink_wool": "ал йон",
  "block.minecraft.gray_wool": "соры йон",
  "block.minecraft.light_gray_wool": "соргылт йон",
  "block.minecraft.cyan_wool": "фирәзә йон",
  "block.minecraft.purple_wool": "шәмәхә йон",
  "block.minecraft.blue_wool": "зәңгәр йон",
  "block.minecraft.brown_wool": "көрән йон",
  "block.minecraft.green_wool": "яшел йон",
  "block.minecraft.red_wool": "кызыл йон",
  "block.minecraft.black_wool": "кара йон",
  "block.minecraft.dandelion": "тузганак",
  "block.minecraft.poppy": "мәк",
  "block.minecraft.blue_orchid": "зәңгәр күке яше",
  "block.minecraft.allium": "сарымсак",
  "block.minecraft.azure_bluet": "зәңгәрсу күкбаш",
  "block.minecraft.red_tulip": "кызыл ләлә",
  "block.minecraft.orange_tulip": "кызгылт сары ләлә",
  "block.minecraft.white_tulip": "ак ләлә",
  "block.minecraft.pink_tulip": "ал ләлә",
  "block.minecraft.oxeye_daisy": "акбаш",
  "block.minecraft.cornflower": "күкчәчәк",
  "block.minecraft.lily_of_the_valley": "энҗе чәчәк",
  "block.minecraft.wither_rose": "визер розасы",
  "block.minecraft.brown_mushroom": "көрән гөмбә",
  "block.minecraft.red_mushroom": "кызыл гөмбә",
  "block.minecraft.crimson_fungus": "кырмызы гөмбә",
  "block.minecraft.warped_fungus": "гаҗәп гөмбә",
  "block.minecraft.crimson_roots": "кырмызы тамырлар",
  "block.minecraft.warped_roots": "гаҗәп тамырлар",
  "block.minecraft.nether_sprouts": "незер үсентесе",
  "block.minecraft.weeping_vines": "бөдрә чыбык",
  "block.minecraft.twisting_vines": "үреленгән чыбык",
  "block.minecraft.sugar_cane": "шикәр камышы",
  "block.minecraft.kelp": "суүсем",
  "block.minecraft.bamboo": "бамбук",
  "block.minecraft.gold_block": "алтын блок",
  "block.minecraft.iron_block": "тимер блок",
  "block.minecraft.oak_slab": "имән плитә",
  "block.minecraft.spruce_slab": "чыршы плитә",
  "block.minecraft.birch_slab": "каен плитә",
  "block.minecraft.jungle_slab": "тропик агач плитә",
  "block.minecraft.acacia_slab": "сәрви плитә",
  "block.minecraft.dark_oak_slab": "кара имән плитә",
  "block.minecraft.crimson_slab": "кырмызы плитә",
  "block.minecraft.warped_slab": "гаҗәп плитә",
  "block.minecraft.stone_slab": "таш плитә",
  "block.minecraft.smooth_stone_slab": "тигез таш плитә",
  "block.minecraft.sandstone_slab": "комташ плитә",
  "block.minecraft.cut_sandstone_slab": "шома комташ плитә",
  "block.minecraft.petrified_oak_slab": "ташланган имән плитә",
  "block.minecraft.cobblestone_slab": "йомрыташ плитә",
  "block.minecraft.brick_slab": "кирпеч плитә",
  "block.minecraft.stone_brick_slab": "таш кирпеч плитә",
  "block.minecraft.nether_brick_slab": "незер кирпеч плитә",
  "block.minecraft.quartz_slab": "кварц плитә",
  "block.minecraft.red_sandstone_slab": "кызыл комташ плитә",
  "block.minecraft.cut_red_sandstone_slab": "шома кызыл комташ плитә",
  "block.minecraft.purpur_slab": "пурпур плитә",
  "block.minecraft.prismarine_slab": "призмарин плитә",
  "block.minecraft.prismarine_brick_slab": "призмарин кирпеч плитә",
  "block.minecraft.dark_prismarine_slab": "кара призмарин плитә",
  "block.minecraft.smooth_quartz": "тигез кварц блок",
  "block.minecraft.smooth_red_sandstone": "тигез кызыл комташ",
  "block.minecraft.smooth_sandstone": "тигез комташ",
  "block.minecraft.smooth_stone": "тигез таш",
  "block.minecraft.bricks": "кирпечләр",
  "block.minecraft.tnt": "динамит",
  "block.minecraft.bookshelf": "китап киштәсе",
  "block.minecraft.mossy_cobblestone": "мүкле йомрыташ",
  "block.minecraft.obsidian": "обсидиан",
  "block.minecraft.torch": "факел",
  "block.minecraft.end_rod": "энд таягы",
  "block.minecraft.chorus_plant": "хорус",
  "block.minecraft.chorus_flower": "хорус чәчәге",
  "block.minecraft.purpur_block": "пурпур",
  "block.minecraft.purpur_pillar": "пурпур багана",
  "block.minecraft.purpur_stairs": "пурпур баскычлар",
  "block.minecraft.spawner": "үрентелек",
  "block.minecraft.oak_stairs": "имән баскычлар",
  "block.minecraft.chest": "сандык",
  "block.minecraft.diamond_ore": "алмаз кызылы",
  "block.minecraft.diamond_block": "алмаз блок",
  "block.minecraft.crafting_table": "верстак",
  "block.minecraft.farmland": "сөрүлек",
  "block.minecraft.furnace": "мич",
  "block.minecraft.ladder": "баскыч",
  "block.minecraft.rail": "тимер юл",
  "block.minecraft.cobblestone_stairs": "йомрыташ баскычлар",
  "block.minecraft.lever": "рычаг",
  "block.minecraft.stone_pressure_plate": "таш басма плитә",
  "block.minecraft.oak_pressure_plate": "имән басма плитә",
  "block.minecraft.spruce_pressure_plate": "чыршы басма плитә",
  "block.minecraft.birch_pressure_plate": "каен басма плитә",
  "block.minecraft.jungle_pressure_plate": "тропик агач басма плитә",
  "block.minecraft.acacia_pressure_plate": "сәрви басма плитә",
  "block.minecraft.dark_oak_pressure_plate": "кара имән басма плитә",
  "block.minecraft.crimson_pressure_plate": "кырмызы басма плитә",
  "block.minecraft.warped_pressure_plate": "гаҗәп басма плитә",
  "block.minecraft.polished_blackstone_pressure_plate": "шомартылган караташ басма плитә",
  "block.minecraft.redstone_ore": "редстоун кызылы",
  "block.minecraft.redstone_torch": "редстоун факел",
  "block.minecraft.snow": "кар",
  "block.minecraft.ice": "боз",
  "block.minecraft.snow_block": "кар блок",
  "block.minecraft.cactus": "кактус",
  "block.minecraft.clay": "балчык",
  "block.minecraft.jukebox": "уйнаткыч",
  "block.minecraft.oak_fence": "имән койма",
  "block.minecraft.spruce_fence": "чыршы койма",
  "block.minecraft.birch_fence": "каен койма",
  "block.minecraft.jungle_fence": "тропик агач койма",
  "block.minecraft.acacia_fence": "сәрви койма",
  "block.minecraft.dark_oak_fence": "кара имән койма",
  "block.minecraft.crimson_fence": "кырмызы койма",
  "block.minecraft.warped_fence": "гаҗәп койма",
  "block.minecraft.pumpkin": "кабак",
  "block.minecraft.carved_pumpkin": "киселгән кабак",
  "block.minecraft.netherrack": "незерташ",
  "block.minecraft.soul_sand": "җан комы",
  "block.minecraft.soul_soil": "җан туфрагы",
  "block.minecraft.basalt": "базальт",
  "block.minecraft.polished_basalt": "шомартылган базальт",
  "block.minecraft.soul_torch": "җан факелы",
  "block.minecraft.glowstone": "яктыташ",
  "block.minecraft.jack_o_lantern": "джек яктырткычы",
  "block.minecraft.oak_trapdoor": "имән люк",
  "block.minecraft.spruce_trapdoor": "чыршы люк",
  "block.minecraft.birch_trapdoor": "каен люк",
  "block.minecraft.jungle_trapdoor": "тропик агач люк",
  "block.minecraft.acacia_trapdoor": "сәрви люк",
  "block.minecraft.dark_oak_trapdoor": "кара имән люк",
  "block.minecraft.crimson_trapdoor": "кырмызы люк",
  "block.minecraft.warped_trapdoor": "гаҗәп люк",
  "block.minecraft.infested_stone": "агуланган таш",
  "block.minecraft.infested_cobblestone": "агуланган йомрыташ",
  "block.minecraft.infested_stone_bricks": "агуланган таш кирпечләр",
  "block.minecraft.infested_mossy_stone_bricks": "агуланган мүкле таш кирпечләр",
  "block.minecraft.infested_cracked_stone_bricks": "агуланган ярылган таш кирпечләр",
  "block.minecraft.infested_chiseled_stone_bricks": "агуланган кисек таш кирпечләр",
  "block.minecraft.stone_bricks": "таш кирпечләр",
  "block.minecraft.mossy_stone_bricks": "мүкле таш кирпечләр",
  "block.minecraft.cracked_stone_bricks": "ярылган таш кирпечләр",
  "block.minecraft.chiseled_stone_bricks": "киселгән таш кирпечләр",
  "block.minecraft.brown_mushroom_block": "көрән гөмбә блогы",
  "block.minecraft.red_mushroom_block": "кызыл гөмбә блогы",
  "block.minecraft.mushroom_stem": "гөмбә сабагы",
  "block.minecraft.iron_bars": "тимер рәшәткәләр",
  "block.minecraft.chain": "чылбыр",
  "block.minecraft.glass_pane": "бизәкле пыяла",
  "block.minecraft.melon": "карбыз",
  "block.minecraft.vine": "лианалар",
  "block.minecraft.oak_fence_gate": "имән капка",
  "block.minecraft.spruce_fence_gate": "чыршы капка",
  "block.minecraft.birch_fence_gate": "каен капка",
  "block.minecraft.jungle_fence_gate": "тропик агач капка",
  "block.minecraft.acacia_fence_gate": "сәрви капка",
  "block.minecraft.dark_oak_fence_gate": "кара имән капка",
  "block.minecraft.crimson_fence_gate": "кырмызы капка",
  "block.minecraft.warped_fence_gate": "гаҗәп капка",
  "block.minecraft.brick_stairs": "кирпеч баскычлар",
  "block.minecraft.stone_brick_stairs": "таш кирпеч баскычлар",
  "block.minecraft.mycelium": "гөмбәлек",
  "block.minecraft.lily_pad": "төнбөек",
  "block.minecraft.nether_bricks": "незер кирпечләре",
  "block.minecraft.cracked_nether_bricks": "ярылган незер кирпечләре",
  "block.minecraft.chiseled_nether_bricks": "кисек незер кирпечләре",
  "block.minecraft.nether_brick_fence": "незер кирпеч койма",
  "block.minecraft.nether_brick_stairs": "незер кирпеч баскычлар",
  "block.minecraft.enchanting_table": "сихер өстәле",
  "block.minecraft.end_portal_frame": "энд портал кысачыгы",
  "block.minecraft.end_stone": "эндерташ",
  "block.minecraft.end_stone_bricks": "эндерташ кирпечләр",
  "block.minecraft.dragon_egg": "аҗдаһа йомыркасы",
  "block.minecraft.redstone_lamp": "редстоун шәме",
  "block.minecraft.sandstone_stairs": "комташ баскычлар",
  "block.minecraft.emerald_ore": "зөбәрҗәт кызылы",
  "block.minecraft.ender_chest": "эндер-сандык",
  "block.minecraft.tripwire_hook": "ыргак",
  "block.minecraft.emerald_block": "зөбәрҗәт блок",
  "block.minecraft.spruce_stairs": "чыршы баскычлар",
  "block.minecraft.birch_stairs": "каен баскычлар",
  "block.minecraft.jungle_stairs": "тропик агач баскычлар",
  "block.minecraft.crimson_stairs": "кырмызы баскычлар",
  "block.minecraft.warped_stairs": "гаҗәп баскычлар",
  "block.minecraft.command_block": "боерык блогы",
  "block.minecraft.beacon": "маяк",
  "block.minecraft.cobblestone_wall": "йомрыташ киртә",
  "block.minecraft.mossy_cobblestone_wall": "мүкле йомрыташ киртә",
  "block.minecraft.brick_wall": "кирпеч киртә",
  "block.minecraft.prismarine_wall": "призмарин киртә",
  "block.minecraft.red_sandstone_wall": "кызыл комташ киртә",
  "block.minecraft.mossy_stone_brick_wall": "мүкле таш кирпеч киртә",
  "block.minecraft.granite_wall": "гранит киртә",
  "block.minecraft.stone_brick_wall": "таш кирпеч киртә",
  "block.minecraft.nether_brick_wall": "незер кирпеч киртә",
  "block.minecraft.andesite_wall": "андезит киртә",
  "block.minecraft.red_nether_brick_wall": "кызыл незер кирпеч киртә",
  "block.minecraft.sandstone_wall": "комташ киртә",
  "block.minecraft.end_stone_brick_wall": "эндерташ кирпеч киртә",
  "block.minecraft.diorite_wall": "диорит киртә",
  "block.minecraft.blackstone_wall": "караташ койма",
  "block.minecraft.polished_blackstone_wall": "шомартылган караташ койма",
  "block.minecraft.polished_blackstone_brick_wall": "шомартылган караташ кирпеч койма",
  "block.minecraft.stone_button": "таш төймә",
  "block.minecraft.oak_button": "имән төймә",
  "block.minecraft.spruce_button": "чыршы төймә",
  "block.minecraft.birch_button": "каен төймә",
  "block.minecraft.jungle_button": "тропик агач төймә",
  "block.minecraft.acacia_button": "сәрви төймә",
  "block.minecraft.dark_oak_button": "кара имән төймә",
  "block.minecraft.crimson_button": "кырмызы төймә",
  "block.minecraft.warped_button": "гаҗәп төймә",
  "block.minecraft.polished_blackstone_button": "шомартылган караташ төймә",
  "block.minecraft.anvil": "сандал",
  "block.minecraft.chipped_anvil": "бозылган сандал",
  "block.minecraft.damaged_anvil": "ватылган сандал",
  "block.minecraft.trapped_chest": "капкын сандык",
  "block.minecraft.light_weighted_pressure_plate": "авырлык плитә",
  "block.minecraft.heavy_weighted_pressure_plate": "салмакрак авырлык плитә",
  "block.minecraft.daylight_detector": "көндезге яктылык датчигы",
  "block.minecraft.redstone_block": "редстоун блок",
  "block.minecraft.nether_quartz_ore": "незер-кварц кызылы",
  "block.minecraft.hopper": "бүрәнкә",
  "block.minecraft.chiseled_quartz_block": "кисек кварц блок",
  "block.minecraft.quartz_block": "кварц блок",
  "block.minecraft.quartz_bricks": "кварц кирпечләр",
  "block.minecraft.quartz_pillar": "кварц багана",
  "block.minecraft.quartz_stairs": "кварц баскычлар",
  "block.minecraft.activator_rail": "активлашучы тимер юл",
  "block.minecraft.dropper": "ташлаткыч",
  "block.minecraft.white_terracotta": "ак керамика",
  "block.minecraft.orange_terracotta": "кызгылт сары керамика",
  "block.minecraft.magenta_terracotta": "куе кызыл керамика",
  "block.minecraft.light_blue_terracotta": "зәңгәрсу керамика",
  "block.minecraft.yellow_terracotta": "сары керамика",
  "block.minecraft.lime_terracotta": "яшькелт керамика",
  "block.minecraft.pink_terracotta": "ал керамика",
  "block.minecraft.gray_terracotta": "соры керамика",
  "block.minecraft.light_gray_terracotta": "соргылт керамика",
  "block.minecraft.cyan_terracotta": "фирәзә керамика",
  "block.minecraft.purple_terracotta": "шәмәхә керамика",
  "block.minecraft.blue_terracotta": "зәңгәр керамика",
  "block.minecraft.brown_terracotta": "көрән керамика",
  "block.minecraft.green_terracotta": "яшел керамика",
  "block.minecraft.red_terracotta": "кызыл керамика",
  "block.minecraft.black_terracotta": "кара керамика",
  "block.minecraft.barrier": "киртә",
  "block.minecraft.iron_trapdoor": "тимер люк",
  "block.minecraft.hay_block": "печән бәйләме",
  "block.minecraft.white_carpet": "ак келәм",
  "block.minecraft.orange_carpet": "кызгылт сары келәм",
  "block.minecraft.magenta_carpet": "куе кызыл келәм",
  "block.minecraft.light_blue_carpet": "зәңгәрсу келәм",
  "block.minecraft.yellow_carpet": "сары келәм",
  "block.minecraft.lime_carpet": "яшькелт келәм",
  "block.minecraft.pink_carpet": "ал келәм",
  "block.minecraft.gray_carpet": "соры келәм",
  "block.minecraft.light_gray_carpet": "соргылт келәм",
  "block.minecraft.cyan_carpet": "фирәзә келәм",
  "block.minecraft.purple_carpet": "шәмәхә келәм",
  "block.minecraft.blue_carpet": "зәңгәр келәм",
  "block.minecraft.brown_carpet": "көрән келәм",
  "block.minecraft.green_carpet": "яшел келәм",
  "block.minecraft.red_carpet": "кызыл келәм",
  "block.minecraft.black_carpet": "кара келәм",
  "block.minecraft.terracotta": "керамика",
  "block.minecraft.coal_block": "күмер блок",
  "block.minecraft.packed_ice": "калын боз",
  "block.minecraft.acacia_stairs": "сәрви баскычлар",
  "block.minecraft.dark_oak_stairs": "кара имән баскычлар",
  "block.minecraft.slime_block": "лайлач блок",
  "block.minecraft.grass_path": "сукмак",
  "block.minecraft.sunflower": "көнбагыш",
  "block.minecraft.lilac": "канәфер",
  "block.minecraft.rose_bush": "гөлчәчәк куагы",
  "block.minecraft.peony": "чалма чәчәк",
  "block.minecraft.tall_grass": "озын үлән",
  "block.minecraft.large_fern": "эре абага",
  "block.minecraft.white_stained_glass": "ак пыяла",
  "block.minecraft.orange_stained_glass": "кызгылт сары пыяла",
  "block.minecraft.magenta_stained_glass": "куе кызыл пыяла",
  "block.minecraft.light_blue_stained_glass": "зәңгәрсу пыяла",
  "block.minecraft.yellow_stained_glass": "сары пыяла",
  "block.minecraft.lime_stained_glass": "яшькелт пыяла",
  "block.minecraft.pink_stained_glass": "ал пыяла",
  "block.minecraft.gray_stained_glass": "соры пыяла",
  "block.minecraft.light_gray_stained_glass": "соргылт пыяла",
  "block.minecraft.cyan_stained_glass": "фирәзә пыяла",
  "block.minecraft.purple_stained_glass": "шәмәхә пыяла",
  "block.minecraft.blue_stained_glass": "зәңгәр пыяла",
  "block.minecraft.brown_stained_glass": "көрән пыяла",
  "block.minecraft.green_stained_glass": "яшел пыяла",
  "block.minecraft.red_stained_glass": "кызыл пыяла",
  "block.minecraft.black_stained_glass": "кара пыяла",
  "block.minecraft.white_stained_glass_pane": "ак бизәкле пыяла",
  "block.minecraft.orange_stained_glass_pane": "кызгылт сары бизәкле пыяла",
  "block.minecraft.magenta_stained_glass_pane": "куе кызыл бизәкле пыяла",
  "block.minecraft.light_blue_stained_glass_pane": "зәңгәрсу бизәкле пыяла",
  "block.minecraft.yellow_stained_glass_pane": "сары бизәкле пыяла",
  "block.minecraft.lime_stained_glass_pane": "яшькелт бизәкле пыяла",
  "block.minecraft.pink_stained_glass_pane": "ал бизәкле пыяла",
  "block.minecraft.gray_stained_glass_pane": "соры бизәкле пыяла",
  "block.minecraft.light_gray_stained_glass_pane": "соргылт бизәкле пыяла",
  "block.minecraft.cyan_stained_glass_pane": "фирәзә бизәкле пыяла",
  "block.minecraft.purple_stained_glass_pane": "шәмәхә бизәкле пыяла",
  "block.minecraft.blue_stained_glass_pane": "зәңгәр бизәкле пыяла",
  "block.minecraft.brown_stained_glass_pane": "көрән бизәкле пыяла",
  "block.minecraft.green_stained_glass_pane": "яшел бизәкле пыяла",
  "block.minecraft.red_stained_glass_pane": "кызыл бизәкле пыяла",
  "block.minecraft.black_stained_glass_pane": "кара бизәкле пыяла",
  "block.minecraft.prismarine": "призмарин",
  "block.minecraft.prismarine_bricks": "призмарин кирпечләр",
  "block.minecraft.dark_prismarine": "кара призмарин",
  "block.minecraft.prismarine_stairs": "призмарин баскычлар",
  "block.minecraft.prismarine_brick_stairs": "призмарин кирпеч баскычлар",
  "block.minecraft.dark_prismarine_stairs": "кара призмарин баскычлар",
  "block.minecraft.sea_lantern": "диңгез лампасы",
  "block.minecraft.red_sandstone": "кызыл комташ",
  "block.minecraft.chiseled_red_sandstone": "кисек кызыл комташ",
  "block.minecraft.cut_red_sandstone": "шома кызыл комташ",
  "block.minecraft.red_sandstone_stairs": "кызыл комташ баскычлар",
  "block.minecraft.repeating_command_block": "кабатлаучы боерык блок",
  "block.minecraft.chain_command_block": "эзлекле боерык блок",
  "block.minecraft.magma_block": "магма",
  "block.minecraft.nether_wart_block": "незер үскене блогы",
  "block.minecraft.warped_wart_block": "гаҗәп үскене блок",
  "block.minecraft.red_nether_bricks": "кызыл незер кирпече",
  "block.minecraft.bone_block": "сөяк блогы",
  "block.minecraft.structure_void": "буш блогы",
  "block.minecraft.observer": "күзәтүче",
  "block.minecraft.shulker_box": "шалкер тартмасы",
  "block.minecraft.white_shulker_box": "ак шалкер тартмасы",
  "block.minecraft.orange_shulker_box": "кызгылт сары шалкер тартмасы",
  "block.minecraft.magenta_shulker_box": "куе кызыл шалкер тартмасы",
  "block.minecraft.light_blue_shulker_box": "зәңгәрсу шалкер тартмасы",
  "block.minecraft.yellow_shulker_box": "сары шалкер тартмасы",
  "block.minecraft.lime_shulker_box": "яшькелт шалкер тартмасы",
  "block.minecraft.pink_shulker_box": "ал шалкер тартмасы",
  "block.minecraft.gray_shulker_box": "соры шалкер тартмасы",
  "block.minecraft.light_gray_shulker_box": "соргылт шалкер тартмасы",
  "block.minecraft.cyan_shulker_box": "фирәзә шалкер тартмасы",
  "block.minecraft.purple_shulker_box": "шәмәхә шалкер тартмасы",
  "block.minecraft.blue_shulker_box": "зәңгәр шалкер тартмасы",
  "block.minecraft.brown_shulker_box": "көрән шалкер тартмасы",
  "block.minecraft.green_shulker_box": "яшел шалкер тартмасы",
  "block.minecraft.red_shulker_box": "кызыл шалкер тартмасы",
  "block.minecraft.black_shulker_box": "кара шалкер тартмасы",
  "block.minecraft.white_glazed_terracotta": "ак глазурьланган керамика",
  "block.minecraft.orange_glazed_terracotta": "кызгылт сары глазурьланган керамика",
  "block.minecraft.magenta_glazed_terracotta": "куе кызыл глазурьланган керамика",
  "block.minecraft.light_blue_glazed_terracotta": "зәңгәрсу глазурьланган керамика",
  "block.minecraft.yellow_glazed_terracotta": "сары глазурьланган керамика",
  "block.minecraft.lime_glazed_terracotta": "яшькелт глазурьланган керамика",
  "block.minecraft.pink_glazed_terracotta": "ал глазурьланган керамика",
  "block.minecraft.gray_glazed_terracotta": "соры глазурьланган керамика",
  "block.minecraft.light_gray_glazed_terracotta": "соргылт глазурьланган керамика",
  "block.minecraft.cyan_glazed_terracotta": "фирәзә глазурьланган керамика",
  "block.minecraft.purple_glazed_terracotta": "шәмәхә глазурьланган керамика",
  "block.minecraft.blue_glazed_terracotta": "зәңгәр глазурьланган керамика",
  "block.minecraft.brown_glazed_terracotta": "көрән глазурьланган керамика",
  "block.minecraft.green_glazed_terracotta": "яшел глазурьланган керамика",
  "block.minecraft.red_glazed_terracotta": "кызыл глазурьланган керамика",
  "block.minecraft.black_glazed_terracotta": "кара глазурьланган керамика",
  "block.minecraft.white_concrete": "ак бетон",
  "block.minecraft.orange_concrete": "кызгылт сары бетон",
  "block.minecraft.magenta_concrete": "куе кызыл бетон",
  "block.minecraft.light_blue_concrete": "зәңгәрсу бетон",
  "block.minecraft.yellow_concrete": "сары бетон",
  "block.minecraft.lime_concrete": "яшькелт бетон",
  "block.minecraft.pink_concrete": "ал бетон",
  "block.minecraft.gray_concrete": "соры бетон",
  "block.minecraft.light_gray_concrete": "соргылт бетон",
  "block.minecraft.cyan_concrete": "фирәзә бетон",
  "block.minecraft.purple_concrete": "шәмәхә бетон",
  "block.minecraft.blue_concrete": "зәңгәр бетон",
  "block.minecraft.brown_concrete": "көрән бетон",
  "block.minecraft.green_concrete": "яшел бетон",
  "block.minecraft.red_concrete": "кызыл бетон",
  "block.minecraft.black_concrete": "кара бетон",
  "block.minecraft.white_concrete_powder": "ак коры бетон",
  "block.minecraft.orange_concrete_powder": "кызгылт сары коры бетон",
  "block.minecraft.magenta_concrete_powder": "куе кызыл коры бетон",
  "block.minecraft.light_blue_concrete_powder": "зәңгәрсу коры бетон",
  "block.minecraft.yellow_concrete_powder": "сары коры бетон",
  "block.minecraft.lime_concrete_powder": "яшькелт коры бетон",
  "block.minecraft.pink_concrete_powder": "ал коры бетон",
  "block.minecraft.gray_concrete_powder": "соры коры бетон",
  "block.minecraft.light_gray_concrete_powder": "соргылт коры бетон",
  "block.minecraft.cyan_concrete_powder": "фирәзә коры бетон",
  "block.minecraft.purple_concrete_powder": "шәмәхә коры бетон",
  "block.minecraft.blue_concrete_powder": "зәңгәр коры бетон",
  "block.minecraft.brown_concrete_powder": "көрән коры бетон",
  "block.minecraft.green_concrete_powder": "яшел коры бетон",
  "block.minecraft.red_concrete_powder": "кызыл коры бетон",
  "block.minecraft.black_concrete_powder": "кара коры бетон",
  "block.minecraft.turtle_egg": "ташбака йомыркасы",
  "block.minecraft.dead_tube_coral_block": "үле торбасыман мәрҗән блогы",
  "block.minecraft.dead_brain_coral_block": "үле ми мәрҗән блогы",
  "block.minecraft.dead_bubble_coral_block": "үле куыклык мәрҗән блогы",
  "block.minecraft.dead_fire_coral_block": "үле ут мәрҗән блогы",
  "block.minecraft.dead_horn_coral_block": "үле мөгез мәрҗән блогы",
  "block.minecraft.tube_coral_block": "торбасыман мәрҗән блогы",
  "block.minecraft.brain_coral_block": "ми мәрҗәне блогы",
  "block.minecraft.bubble_coral_block": "куыклык мәрҗән блогы",
  "block.minecraft.fire_coral_block": "ут мәрҗән блогы",
  "block.minecraft.horn_coral_block": "мөгез мәрҗән блогы",
  "block.minecraft.tube_coral": "торбасыман мәрҗән",
  "block.minecraft.brain_coral": "ми мәрҗәне",
  "block.minecraft.bubble_coral": "куыклы мәрҗән",
  "block.minecraft.fire_coral": "ут мәрҗән",
  "block.minecraft.horn_coral": "мөгез мәрҗән",
  "block.minecraft.dead_brain_coral": "үле ми мәрҗән",
  "block.minecraft.dead_bubble_coral": "үле куыклык мәрҗән",
  "block.minecraft.dead_fire_coral": "үле ут мәрҗән",
  "block.minecraft.dead_horn_coral": "үле мөгез мәрҗән",
  "block.minecraft.dead_tube_coral": "үле торбасыман мәрҗән",
  "block.minecraft.tube_coral_fan": "җилпәзә торбасыман мәрҗән",
  "block.minecraft.brain_coral_fan": "җилпәзәле ми мәрҗәне",
  "block.minecraft.bubble_coral_fan": "җилпәзә куыклык мәрҗән",
  "block.minecraft.fire_coral_fan": "җилпәзә ут мәрҗән",
  "block.minecraft.horn_coral_fan": "җилпәзә мөгез мәрҗән",
  "block.minecraft.dead_tube_coral_fan": "үле җилпәзә торбасыман мәрҗән",
  "block.minecraft.dead_brain_coral_fan": "үле җилпәзә ми мәрҗән",
  "block.minecraft.dead_bubble_coral_fan": "үле җилпәзә куыклык мәрҗән",
  "block.minecraft.dead_fire_coral_fan": "үле җилпәзә ут мәрҗән",
  "block.minecraft.dead_horn_coral_fan": "үле җилпәзә мөгез мәрҗән",
  "block.minecraft.blue_ice": "зәңгәр боз",
  "block.minecraft.conduit": "диңгез чыганагы",
  "block.minecraft.polished_granite_stairs": "шомартылган гранит баскычлар",
  "block.minecraft.smooth_red_sandstone_stairs": "тигез кызыл комташ баскычлар",
  "block.minecraft.mossy_stone_brick_stairs": "мүкле таш кирпеч баскычлар",
  "block.minecraft.polished_diorite_stairs": "шомартылган диорит баскычлар",
  "block.minecraft.mossy_cobblestone_stairs": "мүкле йомрыташ баскычлар",
  "block.minecraft.end_stone_brick_stairs": "эндерташ кирпеч баскычлар",
  "block.minecraft.stone_stairs": "таш баскычлар",
  "block.minecraft.smooth_sandstone_stairs": "тигез комташ баскычлар",
  "block.minecraft.smooth_quartz_stairs": "тигез кварц баскычлар",
  "block.minecraft.granite_stairs": "гранит баскычлар",
  "block.minecraft.andesite_stairs": "андезит баскычлар",
  "block.minecraft.red_nether_brick_stairs": "кызыл незер кирпеч баскычлар",
  "block.minecraft.polished_andesite_stairs": "шомартылган андезит баскычлар",
  "block.minecraft.diorite_stairs": "диорит баскычлар",
  "block.minecraft.polished_granite_slab": "шомартылган гранит плитә",
  "block.minecraft.smooth_red_sandstone_slab": "тигез кызыл комташ плитә",
  "block.minecraft.mossy_stone_brick_slab": "мүкле таш кирпеч плитә",
  "block.minecraft.polished_diorite_slab": "шомартылган диорит плитә",
  "block.minecraft.mossy_cobblestone_slab": "мүкле йомрыташ плитә",
  "block.minecraft.end_stone_brick_slab": "эндерташ кирпеч плитә",
  "block.minecraft.smooth_sandstone_slab": "тигез комташ плитә",
  "block.minecraft.smooth_quartz_slab": "тигез кварц плитә",
  "block.minecraft.granite_slab": "гранит плитә",
  "block.minecraft.andesite_slab": "андезит плитә",
  "block.minecraft.red_nether_brick_slab": "кызыл незер кирпеч плитә",
  "block.minecraft.polished_andesite_slab": "шомартылган андезит плитә",
  "block.minecraft.diorite_slab": "диорит плитә",
  "block.minecraft.scaffolding": "таскак",
  "block.minecraft.iron_door": "тимер ишек",
  "block.minecraft.oak_door": "имән ишек",
  "block.minecraft.spruce_door": "чыршы ишек",
  "block.minecraft.birch_door": "каен ишек",
  "block.minecraft.jungle_door": "тропик агач ишек",
  "block.minecraft.acacia_door": "сәрви ишек",
  "block.minecraft.dark_oak_door": "кара имән ишек",
  "block.minecraft.crimson_door": "кырмызы ишек",
  "block.minecraft.warped_door": "гаҗәп ишек",
  "block.minecraft.repeater": "редстоун кабатлаучы",
  "block.minecraft.comparator": "редстоун компаратор",
  "block.minecraft.structure_block": "структуралы блок",
  "block.minecraft.jigsaw": "пазл",
  "item.minecraft.turtle_helmet": "ташбака кабырчыгы□□башта:□+2 көбә",
  "item.minecraft.scute": "калканчык",
  "item.minecraft.iron_shovel": "тимер көрәк□□төп кулда:□+3.5 зыян□-3 һөҗүм тизлеге",
  "item.minecraft.iron_pickaxe": "тимер кәйлә□□төп кулда:□+3 зыян□-2.8 һөҗүм тизлеге",
  "item.minecraft.iron_axe": "тимер балта□□төп кулда:□+8 зыян□-3.1 һөҗүм тизлеге",
  "item.minecraft.flint_and_steel": "чакма",
  "item.minecraft.apple": "алма",
  "item.minecraft.bow": "җәя",
  "item.minecraft.arrow": "ук",
  "item.minecraft.coal": "күмер",
  "item.minecraft.charcoal": "агач күмер",
  "item.minecraft.diamond": "алмаз",
  "item.minecraft.iron_ingot": "тимер коелма",
  "item.minecraft.gold_ingot": "алтын коелма",
  "item.minecraft.netherite_ingot": "незерит коелма",
  "item.minecraft.netherite_scrap": "незерит ватыгы",
  "item.minecraft.iron_sword": "тимер кылыч□□төп кулда:□+5 зыян□-2.4 һөҗүм тизлеге",
  "item.minecraft.wooden_sword": "агач кылыч□□төп кулда:□+3 зыян□-2.4 һөҗүм тизлеге",
  "item.minecraft.wooden_shovel": "агач көрәк□□төп кулда:□+1.5 зыян□-3 һөҗүм тизлеге",
  "item.minecraft.wooden_pickaxe": "агач кәйлә□□төп кулда:□+1 зыян□-2.8 һөҗүм тизлеге",
  "item.minecraft.wooden_axe": "агач балта□□төп кулда:□+6 зыян□-3.2 һөҗүм тизлеге",
  "item.minecraft.stone_sword": "таш кылыч□□төп кулда:□+4 зыян□-2.4 һөҗүм тизлеге",
  "item.minecraft.stone_shovel": "таш көрәк□□төп кулда:□+2.5 зыян□-3 һөҗүм тизлеге",
  "item.minecraft.stone_pickaxe": "таш кәйлә□□төп кулда:□+2 зыян□-2.8 һөҗүм тизлеге",
  "item.minecraft.stone_axe": "таш балта□□төп кулда:□+8 зыян□-3.2 һөҗүм тизлеге",
  "item.minecraft.diamond_sword": "алмаз кылыч□□төп кулда:□+6 зыян□-2.4 һөҗүм тизлеге",
  "item.minecraft.diamond_shovel": "алмаз көрәк□□төп кулда:□+4.5 зыян□-3 һөҗүм тизлеге",
  "item.minecraft.diamond_pickaxe": "алмаз кәйлә□□төп кулда:□+4 зыян□-2.8 һөҗүм тизлеге",
  "item.minecraft.diamond_axe": "алмаз балта□□төп кулда:□+8 зыян□-3 һөҗүм тизлеге",
  "item.minecraft.stick": "таяк",
  "item.minecraft.bowl": "тәлинкә",
  "item.minecraft.mushroom_stew": "гөмбә ашы",
  "item.minecraft.golden_sword": "алтын кылыч□□төп кулда:□+3 зыян□-2.4 һөҗүм тизлеге",
  "item.minecraft.golden_shovel": "алтын көрәк□□төп кулда:□+1.5 зыян□-3 һөҗүм тизлеге",
  "item.minecraft.golden_pickaxe": "алтын кәйлә□□төп кулда:□+1 зыян□-2.8 һөҗүм тизлеге",
  "item.minecraft.golden_axe": "алтын балта□□төп кулда:□+6 зыян□-3 һөҗүм тизлеге",
  "item.minecraft.netherite_sword": "незерит кылыч□□төп кулда:□+7 зыян□-2.4 һөҗүм тизлеге",
  "item.minecraft.netherite_shovel": "незерит көрәк□□төп кулда:□+5.5 зыян□-3 һөҗүм тизлеге",
  "item.minecraft.netherite_pickaxe": "незерит кәйлә□□төп кулда:□+5 зыян□-2.8 һөҗүм тизлеге",
  "item.minecraft.netherite_axe": "незерит балта□□төп кулда:□+9 зыян□-3 һөҗүм тизлеге",
  "item.minecraft.string": "җеп",
  "item.minecraft.feather": "каурый",
  "item.minecraft.gunpowder": "дары",
  "item.minecraft.wooden_hoe": "агач китмән□□төп кулда:□-3 һөҗүм тизлеге",
  "item.minecraft.stone_hoe": "таш китмән□□төп кулда:□-2 һөҗүм тизлеге",
  "item.minecraft.iron_hoe": "тимер китмән□□төп кулда:□-1 һөҗүм тизлеге",
  "item.minecraft.diamond_hoe": "алмаз китмән□□төп кулда:",
  "item.minecraft.golden_hoe": "алтын китмән□□төп кулда:□-3 һөҗүм тизлеге",
  "item.minecraft.netherite_hoe": "незерит китмән□□төп кулда:",
  "item.minecraft.wheat_seeds": "бодай орлыклары",
  "item.minecraft.wheat": "бодай",
  "item.minecraft.bread": "икмәк",
  "item.minecraft.leather_helmet": "күн башлык□□башта:□+1 көбә",
  "item.minecraft.leather_chestplate": "күн куртка□□тәндә:□+3 көбә",
  "item.minecraft.leather_leggings": "күн ыштан□□аякта:□+2 көбә",
  "item.minecraft.leather_boots": "күн итек□□үкчәдә:□+1 көбә",
  "item.minecraft.chainmail_helmet": "көбә башлык□□башта:□+2 көбә",
  "item.minecraft.chainmail_chestplate": "көбә күкрәкчә□□тәндә:□+5 көбә",
  "item.minecraft.chainmail_leggings": "көбә ыштан□□аякта:□+4 көбә",
  "item.minecraft.chainmail_boots": "көбә итек□□үкчәдә:□+1 көбә",
  "item.minecraft.iron_helmet": "тимер башлык□□башта:□+2 көбә",
  "item.minecraft.iron_chestplate": "тимер күкрәкчә□□тәндә:□+6 көбә",
  "item.minecraft.iron_leggings": "тимер ыштан□□аякта:□+5 көбә",
  "item.minecraft.iron_boots": "тимер итек□□үкчәдә:□+2 көбә",
  "item.minecraft.diamond_helmet": "алмаз башлык□□башта:□+3 көбә□+2 көбә ныклыгы",
  "item.minecraft.diamond_chestplate": "алмаз күкрәкчә□□тәндә:□+8 көбә□+2 көбә ныклыгы",
  "item.minecraft.diamond_leggings": "алмаз ыштан□□аякта:□+6 көбә□+2 көбә ныклыгы",
  "item.minecraft.diamond_boots": "алмаз итек□□үкчәдә:□+3 көбә□+2 көбә ныклыгы",
  "item.minecraft.golden_helmet": "алтын башлык□□башта:□+2 көбә",
  "item.minecraft.golden_chestplate": "алтын күкрәкчә□□тәндә:□+5 көбә",
  "item.minecraft.golden_leggings": "алтын ыштан□□аякта:□+3 көбә",
  "item.minecraft.golden_boots": "алтын итек□□үкчәдә:□+1 көбә",
  "item.minecraft.netherite_helmet": "незерит башлык□□башта:□+3 көбә□+3 көбә ныклыгы□+1 кире кагуга каршылык",
  "item.minecraft.netherite_chestplate": "незерит изү күкрәкчә□□тәндә:□+8 көбә□+3 көбә ныклыгы□+1 кире кагуга каршылык",
  "item.minecraft.netherite_leggings": "незерит ыштан□□аякта:□+6 көбә□+3 көбә ныклыгы□+1 кире кагуга каршылык",
  "item.minecraft.netherite_boots": "незерит итек□□үкчәдә:□+3 көбә□+3 көбә ныклыгы□+1 кире кагуга каршылык",
  "item.minecraft.flint": "чакматаш",
  "item.minecraft.porkchop": "чи дуңгыз ите",
  "item.minecraft.cooked_porkchop": "кыздырган дуңгыз ите",
  "item.minecraft.painting": "рәсем",
  "item.minecraft.golden_apple": "алтын алма",
  "item.minecraft.enchanted_golden_apple": "сихерләнгән алтын алма",
  "block.minecraft.oak_sign": "имән билге",
  "block.minecraft.spruce_sign": "чыршы билге",
  "block.minecraft.birch_sign": "каен билге",
  "block.minecraft.jungle_sign": "тропик агач билге",
  "block.minecraft.acacia_sign": "сәрви билге",
  "block.minecraft.dark_oak_sign": "кара имән билге",
  "block.minecraft.crimson_sign": "кырмызы билге",
  "block.minecraft.warped_sign": "гаҗәп тамга",
  "item.minecraft.bucket": "чиләк",
  "item.minecraft.water_bucket": "су чиләге",
  "item.minecraft.lava_bucket": "лава чиләге",
  "item.minecraft.minecart": "арбачык",
  "item.minecraft.saddle": "утыргыч",
  "item.minecraft.redstone": "редстоун тузаны",
  "item.minecraft.snowball": "йомарланган кар",
  "item.minecraft.oak_boat": "имән көймә",
  "item.minecraft.leather": "тире",
  "item.minecraft.milk_bucket": "сөт чиләге",
  "item.minecraft.pufferfish_bucket": "энәкорсак чиләге",
  "item.minecraft.salmon_bucket": "cөләйман чиләге",
  "item.minecraft.cod_bucket": "тәрәч чиләге",
  "item.minecraft.tropical_fish_bucket": "тропик балык чиләге",
  "item.minecraft.brick": "кирпеч",
  "item.minecraft.clay_ball": "балчык кисәге",
  "block.minecraft.dried_kelp_block": "кипкән суүсем блогы",
  "item.minecraft.paper": "кәгазь",
  "item.minecraft.book": "китап",
  "item.minecraft.slime_ball": "лайла куерыгы",
  "item.minecraft.chest_minecart": "сандыклы арбачык",
  "item.minecraft.furnace_minecart": "мичле арбачык",
  "item.minecraft.egg": "йомырка",
  "item.minecraft.compass": "компас",
  "item.minecraft.fishing_rod": "кармак",
  "item.minecraft.clock": "сәгать",
  "item.minecraft.glowstone_dust": "яктыташ тузаны",
  "item.minecraft.cod": "чи тәрәч",
  "item.minecraft.salmon": "чи сөләйман",
  "item.minecraft.tropical_fish": "тропик балыгы",
  "item.minecraft.pufferfish": "энәкорсак",
  "item.minecraft.cooked_cod": "кыздырган тәрәч",
  "item.minecraft.cooked_salmon": "кыздырган сөләйман",
  "item.minecraft.ink_sac": "кара капчыгы",
  "item.minecraft.red_dye": "кызыл буяу",
  "item.minecraft.green_dye": "яшел буяу",
  "item.minecraft.cocoa_beans": "какао-борчаклары",
  "item.minecraft.lapis_lazuli": "лазурит",
  "item.minecraft.purple_dye": "шәмәхә буяу",
  "item.minecraft.cyan_dye": "фирәзә буяу",
  "item.minecraft.light_gray_dye": "соргылт буяу",
  "item.minecraft.gray_dye": "соры буяу",
  "item.minecraft.pink_dye": "ал буяу",
  "item.minecraft.lime_dye": "яшькелт буяу",
  "item.minecraft.yellow_dye": "сары буяу",
  "item.minecraft.light_blue_dye": "зәңгәрсу буяу",
  "item.minecraft.magenta_dye": "куе кызыл буяу",
  "item.minecraft.orange_dye": "кызгылт сары буяу",
  "item.minecraft.bone_meal": "сөяк оны",
  "item.minecraft.blue_dye": "зәңгәр буяу",
  "item.minecraft.brown_dye": "көрән буяу",
  "item.minecraft.black_dye": "кара буяу",
  "item.minecraft.white_dye": "ак буяу",
  "item.minecraft.bone": "сөяк",
  "item.minecraft.sugar": "шикәр",
  "block.minecraft.cake": "торт",
  "block.minecraft.white_bed": "ак карават",
  "block.minecraft.orange_bed": "кызгылт сары карават",
  "block.minecraft.magenta_bed": "куе кызыл карават",
  "block.minecraft.light_blue_bed": "зәңгәрсу карават",
  "block.minecraft.yellow_bed": "сары карават",
  "block.minecraft.lime_bed": "яшькелт карават",
  "block.minecraft.pink_bed": "ал карават",
  "block.minecraft.gray_bed": "соры карават",
  "block.minecraft.light_gray_bed": "соргылт карават",
  "block.minecraft.cyan_bed": "фирәзә карават",
  "block.minecraft.purple_bed": "шәмәхә карават",
  "block.minecraft.blue_bed": "зәңгәр карават",
  "block.minecraft.brown_bed": "көрән карават",
  "block.minecraft.green_bed": "яшел карават",
  "block.minecraft.red_bed": "кызыл карават",
  "block.minecraft.black_bed": "кара карават",
  "item.minecraft.cookie": "печенье",
  "item.minecraft.filled_map": "карта□#0",
  "item.minecraft.shears": "кайчы",
  "item.minecraft.melon_slice": "карбыз телеме",
  "item.minecraft.dried_kelp": "кипкән суүсем",
  "item.minecraft.pumpkin_seeds": "кабак орлыклары",
  "item.minecraft.melon_seeds": "карбыз орлыклары",
  "item.minecraft.beef": "чи сыер ите",
  "item.minecraft.cooked_beef": "кыздырган сыер ите",
  "item.minecraft.chicken": "чи тавык ите",
  "item.minecraft.cooked_chicken": "кыздырган тавык",
  "item.minecraft.rotten_flesh": "черек тән",
  "item.minecraft.ender_pearl": "эндер энҗе",
  "item.minecraft.blaze_rod": "ялкынлы таяк",
  "item.minecraft.ghast_tear": "гаст яше",
  "item.minecraft.gold_nugget": "алтын кисәге",
  "item.minecraft.nether_wart": "незер үскене",
  "item.minecraft.potion": "булдырмыган эчемлек□тәэсирсез",
  "item.minecraft.glass_bottle": "пыяла шешә",
  "item.minecraft.spider_eye": "үрмәкүч күзе",
  "item.minecraft.fermented_spider_eye": "маринадланган үрмәкүч күзе",
  "item.minecraft.blaze_powder": "ялкынлы порошок",
  "item.minecraft.magma_cream": "магма куерыгы",
  "block.minecraft.brewing_stand": "кайнаткыч",
  "block.minecraft.cauldron": "казан",
  "item.minecraft.ender_eye": "эндер күзе",
  "item.minecraft.glistering_melon_slice": "ялтыравык карбыз телеме",
  "item.minecraft.bat_spawn_egg": "ярканат чакыру йомыркасы",
  "item.minecraft.bee_spawn_egg": "корт чакыру йомыркасы",
  "item.minecraft.blaze_spawn_egg": "аҗаган чакыру йомыркасы",
  "item.minecraft.cat_spawn_egg": "мәче чакыру йомыркасы",
  "item.minecraft.cave_spider_spawn_egg": "мәгарә үрмәкүче чакыру йомыркасы",
  "item.minecraft.chicken_spawn_egg": "тавык чакыру йомыркасы",
  "item.minecraft.cod_spawn_egg": "тәрәч чакыру йомыркасы",
  "item.minecraft.cow_spawn_egg": "сыер чакыру йомыркасы",
  "item.minecraft.creeper_spawn_egg": "крипер чакыру йомыркасы",
  "item.minecraft.dolphin_spawn_egg": "дельфин чакыру йомыркасы",
  "item.minecraft.donkey_spawn_egg": "ишәк чакыру йомыркасы",
  "item.minecraft.drowned_spawn_egg": "баткак чакыру йомыркасы",
  "item.minecraft.elder_guardian_spawn_egg": "борынгы каравылчы чакыру йомыркасы",
  "item.minecraft.enderman_spawn_egg": "эндермен чакыру йомыркасы",
  "item.minecraft.endermite_spawn_egg": "эндермит чакыру йомыркасы",
  "item.minecraft.evoker_spawn_egg": "төфсенләүче чакыру йомыркасы",
  "item.minecraft.fox_spawn_egg": "төлке чакыру йомыркасы",
  "item.minecraft.ghast_spawn_egg": "гаст чакыру йомыркасы",
  "item.minecraft.guardian_spawn_egg": "каравылчы чакыру йомыркасы",
  "item.minecraft.hoglin_spawn_egg": "хоглин чакыру йомыркасы",
  "item.minecraft.horse_spawn_egg": "ат чакыру йомыркасы",
  "item.minecraft.husk_spawn_egg": "үлек чакыру йомыркасы",
  "item.minecraft.llama_spawn_egg": "лама чакыру йомыркасы",
  "item.minecraft.magma_cube_spawn_egg": "магма кубы чакыру йомыркасы",
  "item.minecraft.mooshroom_spawn_egg": "чебен мүүмбәсе чакыру йомыркасы",
  "item.minecraft.mule_spawn_egg": "качыр чакыру йомыркасы",
  "item.minecraft.ocelot_spawn_egg": "оцелот чакыру йомыркасы",
  "item.minecraft.panda_spawn_egg": "панда чакыру йомыркасы",
  "item.minecraft.parrot_spawn_egg": "тутый кош чакыру йомыркасы",
  "item.minecraft.phantom_spawn_egg": "өрәк чакыру йомыркасы",
  "item.minecraft.pig_spawn_egg": "дуңгыз чакыру йомыркасы",
  "item.minecraft.piglin_spawn_egg": "пиглин чакыру йомыркасы",
  "item.minecraft.pillager_spawn_egg": "юлбасар чакыру йомыркасы",
  "item.minecraft.polar_bear_spawn_egg": "ак аю чакыру йомыркасы",
  "item.minecraft.pufferfish_spawn_egg": "энәкорсак чакыру йомыркасы",
  "item.minecraft.rabbit_spawn_egg": "куян чакыру йомыркасы",
  "item.minecraft.ravager_spawn_egg": "бөлдерүче чакыру йомыркасы",
  "item.minecraft.salmon_spawn_egg": "сөләйман чакыру йомыркасы",
  "item.minecraft.sheep_spawn_egg": "сарык чакыру йомыркасы",
  "item.minecraft.shulker_spawn_egg": "шалкер чакыру йомыркасы",
  "item.minecraft.silverfish_spawn_egg": "коңгыз чакыру йомыркасы",
  "item.minecraft.skeleton_spawn_egg": "скелет чакыру йомыркасы",
  "item.minecraft.skeleton_horse_spawn_egg": "скелет ат чакыру йомыркасы",
  "item.minecraft.slime_spawn_egg": "лайлач чакыру йомыркасы",
  "item.minecraft.spider_spawn_egg": "үрмәкүч чакыру йомыркасы",
  "item.minecraft.squid_spawn_egg": "сигезаяк чакыру йомыркасы",
  "item.minecraft.stray_spawn_egg": "сукбай чакыру йомыркасы",
  "item.minecraft.strider_spawn_egg": "страйдер чакыру йомыркасы",
  "item.minecraft.trader_llama_spawn_egg": "сәүдәгәр ламасы чакыру йомыркасы",
  "item.minecraft.tropical_fish_spawn_egg": "тропик балык чакыру йомыркасы",
  "item.minecraft.turtle_spawn_egg": "ташбака чакыру йомыркасы",
  "item.minecraft.vex_spawn_egg": "газаплаучы чакыру йомыркасы",
  "item.minecraft.villager_spawn_egg": "крестьян чакыру йомыркасы",
  "item.minecraft.vindicator_spawn_egg": "яклаучы чакыру йомыркасы",
  "item.minecraft.wandering_trader_spawn_egg": "гизүче сәүдәгәр чакыру йомыркасы",
  "item.minecraft.witch_spawn_egg": "убырлы чакыру йомыркасы",
  "item.minecraft.wither_skeleton_spawn_egg": "визер-скелет чакыру йомыркасы",
  "item.minecraft.wolf_spawn_egg": "бүре чакыру йомыркасы",
  "item.minecraft.zoglin_spawn_egg": "зоглин чакыру йомыркасы",
  "item.minecraft.zombie_spawn_egg": "зомби чакыру йомыркасы",
  "item.minecraft.zombie_horse_spawn_egg": "зомби-ат чакыру йомыркасы",
  "item.minecraft.zombie_villager_spawn_egg": "зомби-крестьян чакыру йомыркасы",
  "item.minecraft.zombified_piglin_spawn_egg": "зомбиланган пиглин чакыру йомыркасы",
  "item.minecraft.experience_bottle": "тәҗрибә шешәсе",
  "item.minecraft.fire_charge": "ут заряды",
  "item.minecraft.writable_book": "китап вә каләм",
  "item.minecraft.written_book": "төгәлләнгән китап",
  "item.minecraft.emerald": "зөбәрҗәт",
  "item.minecraft.item_frame": "кысачык",
  "block.minecraft.flower_pot": "чәчәк чүлмәге",
  "item.minecraft.carrot": "кишер",
  "item.minecraft.potato": "бәрәңге",
  "item.minecraft.baked_potato": "пешкән бәрәңге",
  "item.minecraft.poisonous_potato": "агулы бәрәңге",
  "item.minecraft.map": "буш карта",
  "item.minecraft.golden_carrot": "алтын кишер",
  "block.minecraft.skeleton_skull": "скелет башы",
  "block.minecraft.wither_skeleton_skull": "визер-скелет башы",
  "block.minecraft.player_head": "уенчы башы",
  "block.minecraft.zombie_head": "зомби башы",
  "block.minecraft.creeper_head": "крипер башы",
  "block.minecraft.dragon_head": "аҗдаһа башы",
  "item.minecraft.carrot_on_a_stick": "кишерле кармак",
  "item.minecraft.warped_fungus_on_a_stick": "гаҗәп гөмбәле кармак",
  "item.minecraft.nether_star": "незер йолдызы",
  "item.minecraft.pumpkin_pie": "кабак бәлеше",
  "item.minecraft.firework_rocket": "фейерверк",
  "item.minecraft.firework_star": "фейерверк йолдызы",
  "item.minecraft.enchanted_book": "сихри китап",
  "item.minecraft.nether_brick": "незер кирпеч",
  "item.minecraft.quartz": "незер-кварц",
  "item.minecraft.tnt_minecart": "динамитлы арбачык",
  "item.minecraft.hopper_minecart": "бүрәнкәле арбачык",
  "item.minecraft.prismarine_shard": "призмарин ватык",
  "item.minecraft.prismarine_crystals": "призмарин кристаллы",
  "item.minecraft.rabbit": "чи куян ите",
  "item.minecraft.cooked_rabbit": "кыздырган куян ите",
  "item.minecraft.rabbit_stew": "куян ашы",
  "item.minecraft.rabbit_foot": "куян тәпие",
  "item.minecraft.rabbit_hide": "куян тиресе",
  "item.minecraft.armor_stand": "элгеч",
  "item.minecraft.iron_horse_armor": "тимер ат көбәсе",
  "item.minecraft.golden_horse_armor": "алтын ат көбәсе",
  "item.minecraft.diamond_horse_armor": "алмаз ат көбәсе",
  "item.minecraft.leather_horse_armor": "күн ат көбәсе",
  "item.minecraft.lead": "бау",
  "item.minecraft.name_tag": "тамга",
  "item.minecraft.command_block_minecart": "боерык блоклы арбачык",
  "item.minecraft.mutton": "чи бәрән ите",
  "item.minecraft.cooked_mutton": "кыздырган бәрән ите",
  "block.minecraft.white_banner": "ак байрак",
  "block.minecraft.orange_banner": "кызгылт сары байрак",
  "block.minecraft.magenta_banner": "куе кызыл байрак",
  "block.minecraft.light_blue_banner": "зәңгәрсу байрак",
  "block.minecraft.yellow_banner": "сары байрак",
  "block.minecraft.lime_banner": "яшькелт байрак",
  "block.minecraft.pink_banner": "ал байрак",
  "block.minecraft.gray_banner": "соры байрак",
  "block.minecraft.light_gray_banner": "соргылт байрак",
  "block.minecraft.cyan_banner": "фирәзә байрак",
  "block.minecraft.purple_banner": "шәмәхә байрак",
  "block.minecraft.blue_banner": "зәңгәр байрак",
  "block.minecraft.brown_banner": "көрән байрак",
  "block.minecraft.green_banner": "яшел байрак",
  "block.minecraft.red_banner": "кызыл байрак",
  "block.minecraft.black_banner": "кара байрак",
  "item.minecraft.end_crystal": "энд кристаллы",
  "item.minecraft.chorus_fruit": "хорус җимеше",
  "item.minecraft.popped_chorus_fruit": "куырылган хорус җимеше",
  "item.minecraft.beetroot": "чөгендер",
  "item.minecraft.beetroot_seeds": "чөгендер орлыгы",
  "item.minecraft.beetroot_soup": "чөгендер ашы",
  "item.minecraft.dragon_breath": "аҗдаһа сулышы",
  "item.minecraft.splash_potion": "шартлаулы булдырмыган эчемлек□тәэсирсез",
  "item.minecraft.spectral_arrow": "спектраль ук",
  "item.minecraft.tipped_arrow": "булдырмый торган эчемлек белән эшкәртелгән ук□тәэсирсез",
  "item.minecraft.lingering_potion": "томанлы булдырмыган эчемлек□тәэсирсез",
  "item.minecraft.shield": "калкан",
  "item.minecraft.elytra": "элитра",
  "item.minecraft.spruce_boat": "чыршы көймә",
  "item.minecraft.birch_boat": "каен көймә",
  "item.minecraft.jungle_boat": "тропик агач көймә",
  "item.minecraft.acacia_boat": "сәрви көймә",
  "item.minecraft.dark_oak_boat": "кара имән көймә",
  "item.minecraft.totem_of_undying": "үлемсезлек тотемы",
  "item.minecraft.shulker_shell": "шалкер кабырчыгы",
  "item.minecraft.iron_nugget": "тимер кисәге",
  "item.minecraft.knowledge_book": "белем китабы",
  "item.minecraft.debug_stick": "төзәтү таякчыгы",
  "item.minecraft.music_disc_13": "пластинка□c418 — 13",
  "item.minecraft.music_disc_cat": "пластинка□c418 — cat",
  "item.minecraft.music_disc_blocks": "пластинка□c418 — blocks",
  "item.minecraft.music_disc_chirp": "пластинка□c418 — chirp",
  "item.minecraft.music_disc_far": "пластинка□c418 — far",
  "item.minecraft.music_disc_mall": "пластинка□c418 — mall",
  "item.minecraft.music_disc_mellohi": "пластинка□c418 — mellohi",
  "item.minecraft.music_disc_stal": "пластинка□c418 — stal",
  "item.minecraft.music_disc_strad": "пластинка□c418 — strad",
  "item.minecraft.music_disc_ward": "пластинка□c418 — ward",
  "item.minecraft.music_disc_11": "пластинка□c418 — 11",
  "item.minecraft.music_disc_wait": "пластинка□c418 — wait",
  "item.minecraft.music_disc_pigstep": "пластинка□лина рейн - pigstep",
  "item.minecraft.trident": "өчтырнак□□төп кулда:□+8 зыян□-2.9 һөҗүм тизлеге",
  "item.minecraft.phantom_membrane": "өрәк мембранасы",
  "item.minecraft.nautilus_shell": "наутилус кабырчыгы",
  "item.minecraft.heart_of_the_sea": "диңгез йөрәге",
  "item.minecraft.crossbow": "арбалет",
  "item.minecraft.suspicious_stew": "серле аш",
  "block.minecraft.loom": "туку станы",
  "item.minecraft.flower_banner_pattern": "байрак бизәге□чәчәк",
  "item.minecraft.creeper_banner_pattern": "байрак бизәге□крипер",
  "item.minecraft.skull_banner_pattern": "байрак бизәге□баш сөяге",
  "item.minecraft.mojang_banner_pattern": "байрак бизәге□нидер",
  "item.minecraft.globe_banner_pattern": "байрак бизәге□глобус",
  "item.minecraft.piglin_banner_pattern": "байрак бизәге□чырай",
  "block.minecraft.composter": "черемәче",
  "block.minecraft.barrel": "кисмәк",
  "block.minecraft.smoker": "ыслауханә",
  "block.minecraft.blast_furnace": "эретү миче",
  "block.minecraft.cartography_table": "картограф өстәле",
  "block.minecraft.fletching_table": "җәяче өстәле",
  "block.minecraft.grindstone": "кайрак",
  "block.minecraft.lectern": "кафедра",
  "block.minecraft.smithing_table": "тимерче өстәле",
  "block.minecraft.stonecutter": "ташкискеч",
  "block.minecraft.bell": "чаң",
  "block.minecraft.lantern": "лампа",
  "block.minecraft.soul_lantern": "җан лампасы",
  "item.minecraft.sweet_berries": "баллы җиләкләр",
  "block.minecraft.campfire": "учак",
  "block.minecraft.soul_campfire": "җан учагы",
  "block.minecraft.shroomlight": "яктыгөмбә",
  "item.minecraft.honeycomb": "корт кәрәзләре",
  "block.minecraft.bee_nest": "корт оясы",
  "block.minecraft.beehive": "умарта",
  "item.minecraft.honey_bottle": "бал шешәсе",
  "block.minecraft.honey_block": "бал блогы",
  "block.minecraft.honeycomb_block": "корт кәрәзләр блогы",
  "block.minecraft.lodestone": "магнетит",
  "block.minecraft.netherite_block": "незерит блок",
  "block.minecraft.ancient_debris": "борынгы җимерекләр",
  "block.minecraft.target": "мишень",
  "block.minecraft.crying_obsidian": "елаучы обсидиан",
  "block.minecraft.blackstone": "караташ",
  "block.minecraft.blackstone_slab": "караташ плитә",
  "block.minecraft.blackstone_stairs": "караташ баскычлар",
  "block.minecraft.gilded_blackstone": "алтынланган караташ",
  "block.minecraft.polished_blackstone": "шомартылган караташ",
  "block.minecraft.polished_blackstone_slab": "шомартылган караташ плитә",
  "block.minecraft.polished_blackstone_stairs": "шомартылган караташ баскычлар",
  "block.minecraft.chiseled_polished_blackstone": "кисек шомартылган караташ",
  "block.minecraft.polished_blackstone_bricks": "шомартылган караташ кирпечләр",
  "block.minecraft.polished_blackstone_brick_slab": "шомартылган караташ кирпеч плитә",
  "block.minecraft.polished_blackstone_brick_stairs": "шомартылган караташ кирпеч баскычлар",
  "block.minecraft.cracked_polished_blackstone_bricks": "ярылган шомартылган караташ кирпечләр",
  "block.minecraft.respawn_anchor": "тергезү якоре",
}
export const tt_ru = items; 
